import { ErrorState } from "$components/error-state";
import { LoadingPage } from "$components/loading/loading-page";
import { linkToAuth0Callback } from "$routes/user/links";
import { useAuth0 } from "@auth0/auth0-react";
import { makeStyles } from "@material-ui/core/styles";
import * as React from "react";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

export const RedirectToAuth0Login = () => {
  const navigate = useNavigate();
  const { isLoading, loginWithRedirect, user, isAuthenticated, error } =
    useAuth0();
  const classes = useStyles();

  React.useEffect(() => {
    (async function login() {
      if (!isLoading && !user) {
        await loginWithRedirect({
          // Take users to the login page regardless of how far they got last time
          // Without this users can get "stuck on the MFA page": https://community.auth0.com/t/classic-universal-login-stuck-on-mfa-page-sms/42025/3
          prompt: "login",
        });
      }
    })();
  }, [isLoading, loginWithRedirect, user]);

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(linkToAuth0Callback());
    }
  }, [isAuthenticated, navigate]);

  if (error) {
    return (
      <div className={classes.root}>
        <ErrorState error={error} />
      </div>
    );
  }

  if (isLoading || !isAuthenticated) {
    return (
      <div className={classes.root}>
        <LoadingPage />
      </div>
    );
  }

  return null;
};
